import { useState } from 'react';
import { MoreVertical, Repeat2, Trash } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  dropdownMenuItemDestructiveClass,
} from 'components/ui/dropdown-menu';
import { KBType } from 'features/chat/agent-chat-module/types/kb.service.type';

import { KbDeleteDialog } from './kb-delete-dialog';
import { KbReembedDialog } from './kb-reembed-dialog';

type KbRowActionDropdownProps = {
  documentId: string;
  documentName?: string;
  kbType: KBType;
  projectKey: string;
  onReembedStarted?: () => void;
};

export function KbRowActionDropdown({
  documentId,
  documentName,
  kbType,
  projectKey,
  onReembedStarted,
}: KbRowActionDropdownProps) {
  const { t } = useTranslation();
  const [isReEmbedOpen, setIsReEmbedOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="h-8 w-8 rounded-full">
            <MoreVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            onSelect={(event) => {
              event.preventDefault();
              setIsReEmbedOpen(true);
            }}
          >
            <Repeat2 className="h-4 w-4" />
            {t('RE_EMBED') || 'Re-embed'}
          </DropdownMenuItem>
          <DropdownMenuItem
            className={dropdownMenuItemDestructiveClass}
            onSelect={(event) => {
              event.preventDefault();
              setIsDeleteOpen(true);
            }}
          >
            <Trash className="h-4 w-4" />
            {t('DELETE') || 'Delete'}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <KbReembedDialog
        open={isReEmbedOpen}
        onOpenChange={setIsReEmbedOpen}
        projectKey={projectKey}
        kbs={[{ id: documentId, type: kbType }]}
        documentName={documentName}
        onSuccess={() => onReembedStarted?.()}
      />

      <KbDeleteDialog
        projectKey={projectKey}
        kbId={documentId}
        open={isDeleteOpen}
        onOpenChange={setIsDeleteOpen}
      />
    </>
  );
}
